export default __webpack_public_path__ + "static/media/19.da79a7f7.jpg";